/* @flow strict */

import * as React from 'react';
import './styles.scss';

type PropsType = {
  children: React.Node,
  standart?: boolean,
  styles?: {[string]: any}
};

export const CTooltip = ({ children, standart }: PropsType): React.Element<'div'> => (
  <div className="cTooltip" data-type={`${standart ? '' : 'text'}`}>
    {children}
  </div>
);

export const CTooltipLabel = ({ children, standart }: PropsType): React.Element<'div'> => (
  <div className={standart ? 'cTooltipLabel' : 'cTooltipLabelCustom'}>
    {children}
  </div>
);

export const CTooltipText = ({ children, styles }: PropsType): React.Element<'div'> => (
  <div className="cTooltipText" style={styles}>
    {children}
  </div>
);
